import {Component, Vue} from "vue-property-decorator";
import {icons, Icon} from "~/components/icon";
import {Getter} from "vuex-class";

@Component
export class ClientNav extends Vue {

  @Getter session;

  render(){
    return (
      <nav class="nav">

        <router-link to={{ name: 'home' }} >
          <Icon icon={icons.user} />
          <span>Profil client</span>
        </router-link>

        <router-link to={{ name: 'users' }}>
          <Icon icon={icons.allUsers} />
          <span>Utilisateurs</span>
        </router-link>

        <router-link to={{ name: 'settings' }}>
          <Icon icon={icons.notification} />
          <span>Paramètres</span>
        </router-link>

        <router-link to={{ name: 'stats' }}>
          <Icon icon={icons.stats} />
          <span>Statistiques</span>
        </router-link>

        <router-link to={{ name: 'notifications' }}>
          <Icon icon={icons.notification} />
          <span>Notifications</span>
        </router-link>

        { this.session.functionalities?.allowHomepageEdition && (
          <router-link to={{ name: 'homepages' }}>
            <Icon icon={icons.home} />
            <span>Page d'accueil</span>
          </router-link>
        )}

      </nav>
    );
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-a120678e/client-nav.tsx" });